ko.bindingHandlers.autofocus = {
    update: function (element, valueAccessor) {
        if (valueAccessor()) {
            $(element).attr('autofocus', 'autofocus');

            // IE 9 doesn't support autofocus, but the iOS keyboard next/previous buttons don't work if .focus() is called.
            if (!('autofocus' in document.createElement('input')))
                $(element).focus();
        } else {
            $(element).removeAttr('autofocus');
        }
    }
};

ko.bindingHandlers.readonly = {
    update: function (element, valueAccessor) {
        if (valueAccessor()) {
            $(element).attr('readonly', 'readonly');
        } else {
            $(element).removeAttr('readonly');
        }
    }
};

// Source: http://stackoverflow.com/questions/23087721/call-function-on-enter-key-press-knockout-js
ko.bindingHandlers.enterKey = {
    init: function (element, valueAccessor, allBindings, viewModel) {
        var callback = valueAccessor();
        $(element).keypress(function (event) {
            var keyCode = (event.which ? event.which : event.keyCode);
            if (keyCode === 13) {
                callback.call(viewModel);
                return false;
            }
            return true;
        });
    }
};

// numeric allows 0 through 9 only
ko.bindingHandlers.numeric = {
    init: function (element, valueAccessor) {
        $(element).on("keydown", function (event) {
            // Allow: backspace, delete, tab, escape, and enter
            if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
                // Allow: Ctrl+A, Ctrl+V, Ctrl+C, Ctrl+X
                ((event.keyCode == 65 || event.keyCode == 86 || event.keyCode == 67 || event.keyCode == 88) && event.ctrlKey === true) ||
                // Allow: home, end, left, right
                (event.keyCode >= 35 && event.keyCode <= 39)) {
                // let it happen, don't do anything
                return;
            }
            else {
                // Ensure that it is a number and stop the keypress
                if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                    event.preventDefault();
                }
            }
        });
    }
};

// Currency allows 0 through 9, periods and commas
ko.bindingHandlers.currency = {
    init: function (element, valueAccessor) {
        $(element).on("keydown", function (event) {
            // Allow: backspace, delete, tab, escape, and enter
            if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
                // Allow: Ctrl+A, Ctrl+V, Ctrl+C, Ctrl+X
                ((event.keyCode == 65 || event.keyCode == 86 || event.keyCode == 67 || event.keyCode == 88) && event.ctrlKey === true) ||
                // Allow: . ,
                (event.keyCode == 188 || event.keyCode == 190 || event.keyCode == 110) ||
                // Allow: home, end, left, right
                (event.keyCode >= 35 && event.keyCode <= 39)) {
                // let it happen, don't do anything
                return;
            }
            else {
                // Ensure that it is a number and stop the keypress
                if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                    event.preventDefault();
                }
            }
        });
    }
};

// phone allows 0 through 9 and +-() and space
ko.bindingHandlers.phone = {
    init: function (element, valueAccessor) {
        $(element).on("keydown", function (event) {
            // Allow: backspace, delete, tab, escape, and enter
            if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
                // Allow: Ctrl+A, Ctrl+V, Ctrl+C, Ctrl+X
                ((event.keyCode == 65 || event.keyCode == 86 || event.keyCode == 67 || event.keyCode == 88) && event.ctrlKey === true) ||
                // Allow: . - and space
                (event.keyCode == 190 || event.keyCode == 110 || event.keyCode == 32 || event.keyCode == 189) ||
                // Allow: + ( )
                (event.shiftKey && (event.keyCode == 187 || event.keyCode == 57 || event.keyCode == 48)) ||
                // Allow: home, end, left, right
                (event.keyCode >= 35 && event.keyCode <= 39)) {
                // let it happen, don't do anything
                return;
            }
            else {
                // Ensure that it is a number and stop the keypress
                if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                    event.preventDefault();
                }
            }
        });
    }
};

// Custom ko binding that makes elements shown/hidden via jquery fadeIn/fadeOut
ko.bindingHandlers.fadeVisible = {
    init: function (element, valueAccessor) {
        var value = valueAccessor();
        $(element).toggle(ko.toJS(value));
    },
    update: function (element, valueAccessor) {
        var value = valueAccessor();
        ko.unwrap(value) ? $(element).fadeIn() : $(element).fadeOut();
    }
};

//Keypress event handler
(function(){
   var KEY_CODE_NAME_MAP = {
       '13': 'Enter',
       '32': 'Spacebar',
       '37': 'Left',
       '38': 'Up',
       '39': 'Right',
       '40': 'Down',
       '46': 'Del',
       '91': 'OS',
       '145': 'Scroll'
   };

   var keyPressHandlerFactory = function (handlers) {
       var keyPressHandler = function (data, e) {
           var event = e || data; //this is so that we can support non-knockout event handlers.

           var bubbleAction = true;
           var keyCode = event.keyCode;
           var key = event.key.toLowerCase();
           var altKeyName = (KEY_CODE_NAME_MAP[keyCode] || key).toLowerCase();
           var handlerKey = Object.keys(handlers).find(function (prop) {
               var handlerName = prop.toLowerCase();
               return handlerName === keyCode || handlerName === key || handlerName === altKeyName;
           });

           if (handlerKey) {
               bubbleAction = handlers[handlerKey](data, event) || false;
           }

           //knockout uses jQuery by default. Let's handle the case where jQuery is not used.
           if (!bubbleAction && event.preventDefault && event.stopPropogation) {
               event.preventDefault();
               event.stopPropagation();
           }

           //to support IE and jQuery's event structure.
           return bubbleAction;
       };

       return keyPressHandler;
   }

   var keyPressValueAccessorFactory = function (handlers) {
       return function () {
           return { keydown: keyPressHandlerFactory(handlers) };
       };
   };

   ko.bindingHandlers.keypress = {
       init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
           var newValueAccessor = keyPressValueAccessorFactory(valueAccessor());
           return ko.bindingHandlers['event']['init'].call(this, element, newValueAccessor, allBindings, viewModel, bindingContext);
       }
   };
})();
